import React from 'react';
import moment from 'moment';

import { Spinner, MCButton, MCError } from 'src/components/basic';
import { MCDatePicker, popupModel } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { remCss, withRouter, scssVariables as variables, permissions } from 'src/helpers';

import model from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import PopupSelect from 'src/components/complex/popupSelect';
import { ScheduleCalendar } from './ScheduleCalendar';
import { AccountStateSelect } from 'src/components/user/AccountStateSelect';
import LANG_CONST from 'src/helpers/lang/const';
import slotModel, { SlotSchedule } from 'src/components/slotSchedule';

class Schedule extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      minimizeCalendar: true
    };
  }

  componentDidMount() {
    model.subscribe(this.subscription);
    if (model.state.user?.isDoctor || model.input('doctor')?.id) {
      model.selectDay(model.state.selectedDate || moment(), true);
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  generateSchedule = (props, selectedDate) => {
    if (!slotModel.checkDoctorSelected(model.state.doctor)) return;

    popupModel.setActivePopup('generate_schedule', {
      active: true,
      component: SlotSchedule,
      props: {
        doctorId: model.input('doctor')?.id || 0,
        group: 'year',
        startDate: moment().startOf('day').valueOf(),
        endDate: moment().endOf('year').valueOf(),
        onDone: () => {
          model.emit('reload_schedule');
          popupModel.setActivePopup('generate_schedule', { active: false });
        },
        ...props
      },

      afterHide: () => {
        model.selectDay(selectedDate ? moment(selectedDate) : model.state.selectedDate, true);
      }
    });
  };

  get hours() {
    let min = 9;
    let max = 16;
    model.state.weekSlots.forEach((item) => {
      let startHour = parseInt(moment(item.startDate).format('HH'));
      let endHour = parseInt(moment(item.endDate).format('HH'));
      if (endHour > max) {
        max = endHour;
      }
      if (startHour < min) {
        min = startHour;
      }
    });

    return Array.from({ length: max - min + 1 }, (_, i) => ('0' + (i + min)).slice(-2));
  }

  type = (item) => {
    return item.patientId
      ? 'patient'
      : item.appointmentTypes?.indexOf('in_office') > -1
        ? 'in_office'
        : 'virtual';
  };

  render() {
    const { minimizeCalendar } = this.state;
    const { selectedDate: date, user, doctor } = model.getState();

    let selectedDate = date || moment();
    let smallScreen = this.props.screenDetail.innerWidth < 1025;

    const error = model.getApiState('list').errorMessage;

    return (
      <div className={'mc-container-content mc-schedule'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{permissions.PAGES.SCHEDULE_PAGE.title(user)}</span>
        </div>
        <div className={'mc-flex-20-col'} style={{ overflow: 'auto' }}>
          <div className={'mc-main-content-box'}>
            <MCDatePicker
              selected={selectedDate}
              className={!minimizeCalendar ? 'minimize' : ''}
              isSmall={false}
              hasPastClass={true}
              minDate={moment()}
              onChange={model.selectDay}
              expandRightChild={
                <div className={'mc-grow mc-flex-20'}>
                  {model.state.user?.isDoctor && (
                    <AccountStateSelect template={2} showDuration={!smallScreen} />
                  )}
                  <div style={{ flexGrow: 1 }}></div>
                  <MCButton
                    type={'button'}
                    primary
                    radius
                    medium
                    light
                    iconname={smallScreen ? BASE_ICONS.CALENDAR : null}
                    label={smallScreen ? '' : LANG_CONST.buttons.schedule}
                    style={{ width: 'auto' }}
                    onClick={() => this.generateSchedule()}
                  />
                  {!user?.isDoctor && (
                    <div style={{ width: '30%', minWidth: remCss(200) }}>
                      <PopupSelect
                        template={6}
                        isPopover={true}
                        isClearable={false}
                        placeholder={'Doctor'}
                        name={'doctorId'}
                        value={doctor?.id}
                        defaultValue={true}
                        initSelectedParamKey={'doctorId'}
                        apiConfig={{
                          url: 'clinic/doctor/list',
                          joined: true,
                          labelFn: (user) => <ShortInfo small user={user} specialist={[]} />
                        }}
                        selectedLabelFn={(user) => (
                          <ShortInfo
                            small
                            user={user}
                            specialist={[]}
                            style={{
                              marginTop: remCss(-3),
                              marginBottom: remCss(-3),
                              cursor: 'pointer'
                            }}
                          />
                        )}
                        onChange={(n, v, a) => {
                          model.handleChange('doctor', a?.item);
                          model.selectDay(selectedDate, true);
                        }}
                      />
                    </div>
                  )}
                  <MCButton
                    onClick={() => this.setState({ minimizeCalendar: !minimizeCalendar })}
                    tiny
                    primary
                    light
                    radius
                  >
                    <span
                      className={'mc-rotate ' + (minimizeCalendar ? 'mc-rotate-180' : '')}
                      style={{ height: remCss(44) }}
                    >
                      <SVGIcon
                        iconname={BASE_ICONS.DOWN}
                        width={44}
                        padding={7}
                        fill={variables['colors-mc-primary']}
                      />
                    </span>
                  </MCButton>
                </div>
              }
            />
          </div>
          {!date ? (
            <div className={'mc-m-auto'}>
              <Spinner />
            </div>
          ) : !error ? (
            <ScheduleCalendar hours={this.hours} selectedDate={selectedDate} />
          ) : (
            <MCError error={error.toString()} mcTextProps={{ style: { textAlign: 'center' } }} />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Schedule);
